module.exports = __webpack_public_path__ + "static/img/tst2-09-1.01337c9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-09-1.gif
// module id = 871P
// module chunks = 1